import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-common";

async function katalog() {
  const response = await http
    .getData("/permintaan-bank-darah/katalog")
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function getByRegister(register_id: string | number, jenis?: string) {
  const url = jenis
    ? `/register/${register_id}/permintaan-bank-darah?jenis=${jenis}`
    : `/register/${register_id}/permintaan-bank-darah`;

  const response = await http.getData(url).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function find(id: number) {
  const response = await http
    .getData(`/permintaan-bank-darah/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function create(data: any) {
  const response = await http
    .postData("/permintaan-bank-darah", data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function update(id: number, data: any) {
  const response = await http
    .putData(`/permintaan-bank-darah/${id}`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function destroy(id: number) {
  const response = await http
    .deleteData(`/permintaan-bank-darah/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function signPengirim(id: number, data: { password: string }) {
  const response = await http
    .putData(`/permintaan-bank-darah/${id}/sign-pengirim`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

function printPdf(id: number) {
  window.open(`${http.getAPI()}/permintaan-bank-darah/${id}/pdf`, "_blank");
}

function printLabel(id: number, jumlah: number) {
  window.open(`${http.getAPI()}/permintaan-bank-darah/${id}/label?jumlah=${jumlah}`, "_blank");
}

export default {
  katalog,
  getByRegister,
  find,
  create,
  update,
  destroy,
  signPengirim,
  printPdf,
  printLabel
};
